'use strict';

import angular from 'angular';

export default angular.module('ngOskCrmApp.shared', [])
  .name;



// WEBPACK FOOTER //
// ./client/components/shared/shared.module.js